import { MEDIA, BRAND } from "@/lib/content";
import VisitCounter from "@/components/site/VisitCounter";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-background border-t border-border"
    >
      <div className="container-outer py-14">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img
                src={MEDIA.logo}
                alt={BRAND.short_name}
                className="h-11 w-auto object-contain"
              />
              <div className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-semibold tracking-tight text-accent">
                  {BRAND.short_name}
                </span>
                <span className="text-[10px] tracking-[0.18em] uppercase text-muted-foreground">
                  Consultancy & Electric Solutions Pvt Ltd
                </span>
              </div>
            </div>
            <p className="mt-5 text-sm text-muted-foreground max-w-sm leading-relaxed">
              {BRAND.tagline} A full-stack renewable energy partner for
              EV charging, solar projects and PPA across India.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="overline mb-4">Services</p>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#services" className="hover:text-accent">
                  EV Charging
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-accent">
                  Solar
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-accent">
                  Hybrid Inverters
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-accent">
                  PPA
                </a>
              </li>
              <li>
                <a
                  href="https://scanvio.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent"
                >
                  Scanvio
                </a>
              </li>
              <li>
                <a
                  href="https://cosomicsage.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-accent"
                >
                  CosmicSage
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="overline mb-4">Company</p>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#about" className="hover:text-accent">
                  About
                </a>
              </li>
              <li>
                <a href="#projects" className="hover:text-accent">
                  Projects
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:text-accent">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-4">Get in touch</p>
            <a
              href={`mailto:${BRAND.email}`}
              className="text-sm break-words hover:text-accent"
            >
              {BRAND.email}
            </a>
            <p className="text-sm mt-2">
              <a href={`tel:${BRAND.phone_tel}`} className="hover:text-accent">
                {BRAND.phone}
              </a>
            </p>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-border flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-muted-foreground">
          <div className="flex items-center gap-2">
            {/* Tiny orange rising-sun mark for solar identity */}
            <svg
              width="22"
              height="14"
              viewBox="0 0 22 14"
              fill="none"
              aria-hidden="true"
              className="flex-shrink-0"
            >
              <line x1="0" y1="13" x2="22" y2="13" stroke="#E8762A" strokeWidth="1" strokeLinecap="round" />
              <path d="M 5 13 A 6 6 0 0 1 17 13" stroke="#E8762A" strokeWidth="1.2" fill="none" strokeLinecap="round" />
              <line x1="11" y1="2" x2="11" y2="0.5" stroke="#E8762A" strokeWidth="1" strokeLinecap="round" />
              <line x1="4" y1="5" x2="3" y2="4" stroke="#E8762A" strokeWidth="1" strokeLinecap="round" />
              <line x1="18" y1="5" x2="19" y2="4" stroke="#E8762A" strokeWidth="1" strokeLinecap="round" />
            </svg>
            <p>© {new Date().getFullYear()} {BRAND.legal_name}. All rights reserved.</p>
          </div>
          <div className="flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
            <VisitCounter />
            <p>GSTIN & CIN available on request</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
